// ********************************
// *****  IMAGE LOADER GROUP  *****
// ********************************

// watches all images inside an '.image-loader-group'.
// adds an '.images-loaded' class to that element once they're all loaded.

class ImageLoaderGroup {

    constructor(el) {
        this.el = el;
        this.images = [];
        this.loadCount = 0;
        // find all images in this 'image-loader-group' element
        let findImages = this.el.querySelectorAll('img');
        if(findImages.length > 0) {
            // set target load count valie
            this.loadTarget = findImages.length;
            let _this = this;
            [...findImages].forEach(i => {
                // add listeners etc
                if (i.complete) {
                    _this.hasLoaded();
                } else {
                    i.addEventListener('load', () => {
                        _this.hasLoaded();
                    }, {once: true});
                }
            });
        } else {
            this.el.classList.add('images-loaded');
        }
    }

    hasLoaded() {
        this.loadCount++;
        if(this.loadCount >= this.loadTarget) {
            // add class to 'image-loader-group' element
            this.el.classList.add('images-loaded');
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ImageLoaderGroup(node);
        }
    });
}